import { withLoader, withAsyncEnterLoader } from 'util/routeHelper';

import { getOrderById } from 'actions/booking';
import { getRoomById } from 'actions/room';

export default store => ({
	path: 'payment',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'payment',
				),
			store,
			'PAYMENT',
		),
	},
	onEnter: withAsyncEnterLoader(
		async ({ params: { id: orderId } }, _, updateRatio) => {
			await store.dispatch(getOrderById(orderId));
			updateRatio(0.5);

			const { booking } = store.getState();

			const { roomId } = booking.data[orderId];

			await store.dispatch(getRoomById(roomId));
			updateRatio(0.8);
		},
		store,
		'ENTER_BOOKING_RENEW',
	),
});



// WEBPACK FOOTER //
// ./src/routes/User/Booking/Payment/index.js